import React from 'react';
import { Link } from 'react-router-dom';

import { Box, Theme, Typography, useMediaQuery } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { DateFormats, ROUTING_CONFIG } from '@uplift/constants';
import { useL10n } from '@uplift/hooks';
import { CalendarDateService } from '@uplift/services';
import { Button, StackableCardDeck, StackableCard, Money } from '@uplift/ui-v2';

import { useCurrentuser } from '@uplift/contexts';
import { useFinancePaymentDashboardQuery } from '@uplift/queries';

import { PeriodSummaryCardBasic } from './PeriodSummarySectionBasic.component';


export const PaymentsBasic: React.FC = () => {
  const me = useCurrentuser();
  const l10n = useL10n();

  const isXS = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
  const isMD = useMediaQuery<Theme>(theme => theme.breakpoints.up('md'));
  const isTablet = !isXS && !isMD;

  const now = React.useMemo(() => CalendarDateService.date().format(), []);
  const { data: periodsResult } = useFinancePaymentDashboardQuery(me.id, now);

  const rangeTitle = React.useMemo(() => {
    if (!periodsResult?.data.this) return '';

    const start = CalendarDateService.date(periodsResult?.data.this.started, DateFormats.ISO_DATE);
    const end = CalendarDateService.date(periodsResult?.data.this.ended, DateFormats.ISO_DATE);

    return `${start.date()}–${end.date()}`;
  }, [ periodsResult?.data.this ]);

  const currentMonth = CalendarDateService.date().format('MMM');
  const subtitleMostRecentPayCard = `${currentMonth} ${rangeTitle}`;

  return (
    <div>
      <Box mb={3} mx={{ xs: 2, sm: 0 }} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h3">{l10n.payments.finance}</Typography>

        <Button color="secondary" endIcon={<ArrowForward />} component={Link} to={ROUTING_CONFIG.finance}>
          {l10n.payments.details}
        </Button>
      </Box>
      <StackableCardDeck direction={isTablet ? 'horizontal' : 'vertical'}>
        <StackableCard>
          <PeriodSummaryCardBasic
            title="Current Period"
            range={subtitleMostRecentPayCard}
            value={periodsResult?.data.this.paid === undefined ? undefined : <Money value={periodsResult?.data.this.paid} />}
            disabled={periodsResult?.data.this.paid === 0}
          />
        </StackableCard>
      </StackableCardDeck>
    </div>
  );
};
